import { AccommodationBookingObjectContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface ICabinObjectMetaData {
    content: AccommodationBookingObjectContentResponseModel;
}
const CabinObjectMetaData = ({ content }: ICabinObjectMetaData) => {
    const calcGuests = () => {
        let beds = 0;
        if (content.properties?.numberOfDoubleBeds) beds += content.properties?.numberOfDoubleBeds * 2;
        if (content.properties?.numberOfSingleBeds) beds += content.properties?.numberOfSingleBeds;
        if (content.properties?.numberOfBunkBeds) beds += content.properties?.numberOfBunkBeds * 2;
        return beds;
    };

    return (
        <ul className='list-unstyled d-flex flex-wrap column-gap-1 text-muted font-size-lg mt-2 mb-0'>
            <li className='list-bullet'>{calcGuests()} gäster</li>
            {content.properties?.numberOfRooms && content.properties?.numberOfRooms > 0 ? <li className='list-bullet'>{content.properties?.numberOfRooms} sovrum</li> : null}
            {content.properties?.numberOfBathrooms && content.properties?.numberOfBathrooms > 0 ? <li className='list-bullet'>{content.properties?.numberOfBathrooms} badrum</li> : null}
        </ul>
    );
};

export default CabinObjectMetaData;
